/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Filter_FromInputs */

const vi_warehouse_sales_filter_from = /** @type {(inputs: Warehouse_Sales_Filter_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ ngày`)
};

/**

* @param {Warehouse_Sales_Filter_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_filter_from = /** @type {((inputs?: Warehouse_Sales_Filter_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Filter_FromInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_filter_from(inputs)
});